import { FC } from 'react';
import { Stack, Typography } from '@mui/material';

import { ETicketIconVariants, TicketIcon } from '@mopla/ui';

interface IPriceGroupSubheaderProps {
	text: string;
}

/**
 * Hardcoded subheader shown above the ticket list, e.g.
 * "Tickets - Preisgruppe 1".
 * Per AC: subheader copy is hardcoded for MVP and only the displayCode varies.
 */
export const PriceGroupSubheader: FC<IPriceGroupSubheaderProps> = ({
	text,
}) => {
	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={0.5}
			sx={{ height: 24, width: '100%' }}
		>
			<TicketIcon variant={ETicketIconVariants.PrimaryStroked} size={24} />
			<Typography variant="h5-sb" color="primary.main">
				{text}
			</Typography>
		</Stack>
	);
};
